



















import { defineComponent, getCurrentInstance, Ref } from '@vue/composition-api'
import { ApolloError, NetworkStatus } from 'apollo-client'
import { BIconArrowReturnLeft } from 'bootstrap-vue'

import PageView from '@/components/templates/h/common/tran-ref-item/PageView.vue'
import SettingImportModal from '@/components/templates/h/SettingImportModal.vue'
import {
  tranRefItemExtractCondition,
  tranRefItemOutputCondition,
} from '@/types/entities'
import {
  TemplateFile,
  ResourceType,
  Where,
  WhereOp,
  OrderBy,
  OrderByDirection,
  OrderByNullsOption,
  VUiPTranRefItemsCountDocument,
} from '@/types/generated/graphql'
import {
  OUTPUT_COND_DELETE,
  OUTPUT_COND_ITEM,
  EXPORT_FILENAME,
  SELECT_MAX_COUNT,
} from '@/utils/constant'
import importExportHelper from '@/utils/importExportHelper'
import { addDayYMD } from '@/utils/mixin'
import { setWhereValue, setWhereValues } from '@/utils/searchConditionDef'
import Toast from '@/utils/toast'

const DEFAULT_OUTPUT_CONST = {
  itemOutput: [OUTPUT_COND_ITEM.tanpin],
  delOutput: [],
}
const DEFAULT_EXTRACT_CONST = {
  validData: [addDayYMD(1), '2999-12-31'],
}
export default defineComponent({
  components: { PageView, SettingImportModal },
  layout: 'sidebar',
  created() {
    this.helper = new importExportHelper(this)
  },
  data() {
    return {
      defaultDateValue: DEFAULT_EXTRACT_CONST.validData,
      resourceType: ResourceType.UiPTranRefItem,
      templateFile: TemplateFile.UiPTranRefItem_01,
      extractCondition: {
        validData: DEFAULT_EXTRACT_CONST.validData,
        referrerShobunrui: [],
        referrerShobunruiCount: 0,
        referrerClass: [],
        referrerClassCount: 0,
        referrerCategory: [],
        referrerCategoryCount: 0,
        referrerItem: [],
        referrerItemCount: 0,
        referenceShobunrui: [],
        referenceShobunruiCount: 0,
        referenceClass: [],
        referenceClassCount: 0,
        referenceCategory: [],
        referenceCategoryCount: 0,
        referenceItem: [],
        referenceItemCount: 0,
      },
      outputCondition: DEFAULT_OUTPUT_CONST,
      outputUseList: [
        {
          outputCondType: 'Item',
          displayItems: DEFAULT_OUTPUT_CONST.itemOutput,
          defaultSelected: DEFAULT_OUTPUT_CONST.itemOutput,
          disabledItems: DEFAULT_OUTPUT_CONST.itemOutput,
        },
        {
          outputCondType: 'Delete',
          displayItems: [OUTPUT_COND_DELETE.includeDelete],
          defaultSelected: DEFAULT_OUTPUT_CONST.delOutput,
          disabledItems: [],
        },
      ],
      totalCount: null,
      exportSpinner: false,
    }
  },
  methods: {
    changeExtractCondition(cond: tranRefItemExtractCondition) {
      console.log('changeExtractCondition', cond)
      this.extractCondition = cond
      this.requestCount()
    },
    changeOutputCondition(cond: tranRefItemOutputCondition) {
      console.log('changeOutputCondition', cond)
      this.outputCondition = cond
      this.requestCount()
    },
    async requestCount() {
      this.exportSpinner = true
      this.totalCount = null
      if (this.checkRequired(false)) {
        try {
          const result = await this.$apollo.query({
            query: VUiPTranRefItemsCountDocument,
            variables: { where: this._createWhere() },
          })
          const data = result.data.vUiPTranRefItems.totalCount
          this.totalCount = data.toString()
          this.exportSpinner = false
        } catch (e) {
          console.error(e)
          this.exportSpinner = false
          this.totalCount = '-'
        }
      } else {
        this.exportSpinner = false
        this.totalCount = '-'
      }
    },
    //　入力チェック
    checkRequired(showToast: boolean) {
      // 入力チェック開始
      let errMsg = []
      const hasReferrer =
        this.extractCondition.referrerShobunrui.length > 0 ||
        this.extractCondition.referrerClass.length > 0 ||
        this.extractCondition.referrerCategory.length > 0 ||
        this.extractCondition.referrerItem.length > 0
      const hasReference =
        this.extractCondition.referenceShobunrui.length > 0 ||
        this.extractCondition.referenceClass.length > 0 ||
        this.extractCondition.referenceCategory.length > 0 ||
        this.extractCondition.referenceItem.length > 0
      // 必須項目チェック
      if (
        !this.extractCondition.validData[0] ||
        !this.extractCondition.validData[1] ||
        (!hasReferrer && !hasReference)
      ) {
        errMsg.push({
          message: this.$i18n.t('error.requiredItemNotInput'),
        })
      }
      // 選択数上限チェック（参照元）
      if (this.extractCondition.referrerShobunruiCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.shobunrui'),
            selected: this.extractCondition.referrerShobunruiCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.referrerClassCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.class'),
            selected: this.extractCondition.referrerClassCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.referrerCategoryCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.category'),
            selected: this.extractCondition.referrerCategoryCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.referrerItemCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.referrerItem'),
            selected: this.extractCondition.referrerItemCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      // 選択数上限チェック（参照先）
      if (this.extractCondition.referenceShobunruiCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.shobunrui'),
            selected: this.extractCondition.referenceShobunruiCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.referenceClassCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.class'),
            selected: this.extractCondition.referenceClassCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.referenceCategoryCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.category'),
            selected: this.extractCondition.referenceCategoryCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.referenceItemCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.refferenceItem'),
            selected: this.extractCondition.referenceItemCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (errMsg.length) {
        if (showToast) {
          for (const msg of errMsg) {
            Toast.error(this, msg)
          }
        }
        // 入力チェックに引っかかった場合はエクスポートの要求を出さない
        return false
      }
      return true
    },
    /*********************************
     * 以下はインポートリクエスト用の処理
     *********************************/
    requestImport() {
      console.log('requestImport')
      this.$refs.settingImportModal.show()
    },
    /**
     * インポート開始処理
     */
    async importFileUpload(files: File[]) {
      console.log('importFileUpload', { files })
      this.helper.import({ files: files, resourceType: this.resourceType })
    },
    /*********************************
     * 以下はエクスポートリクエスト用の処理
     *********************************/
    /**
     * エクスポート処理
     */
    async requestExport() {
      if (this.checkRequired(true)) {
        // this._create_query_string()
        await this.helper.export({
          query: this._create_query_string(),
          jmespathQuery:
            'data.vUiPTranRefItems.edges[].node | map(&merge(`{"__update": null}`, @), @)',
          templateFile: this.templateFile,
          filenameExport: EXPORT_FILENAME.tran_ref_item,
        })
      }
    },

    _create_query_string() {
      const where = this._createWhere()
      const rowQuery = `
query {
  vUiPTranRefItems(
    where: ${this.helper.generateQueryWhereString(where)}
    orderBy: ${this._createOrderByString()}
  ) {
    edges {
      node {
        inactiveFlg
        referrerItemCd
        referrerItemCdName
        refferenceItemCd
        refferenceItemCdName
        expireDate
        configuredFlg
        lastModifiedDatetime
        lastModifiedUserName
      }
    }
  }
}
`
      return this.helper.generateQueryString({
        rowQuery: rowQuery,
        resourceType: this.resourceType,
        where: where,
      })
    },
    _createWhere() {
      const TRAN_REF_ITEM_SEARCH_CONDITION: Where[] = [
        // 抽出条件
        { field: ['expireDate'], op: WhereOp.Ge, value: [''] },
        // 参照元（小分類／クラス／カテゴリ／単品）
        { field: ['referrerItem/category1'], op: WhereOp.In, value: [''] },
        { field: ['referrerItem/category2'], op: WhereOp.In, value: [''] },
        { field: ['referrerItem/category3'], op: WhereOp.In, value: [''] },
        { field: ['referrerItemCd'], op: WhereOp.In, value: [''] },
        // 参照先（小分類／クラス／カテゴリ／単品）
        { field: ['refferenceItem/category1'], op: WhereOp.In, value: [''] },
        { field: ['refferenceItem/category2'], op: WhereOp.In, value: [''] },
        { field: ['refferenceItem/category3'], op: WhereOp.In, value: [''] },
        { field: ['refferenceItemCd'], op: WhereOp.In, value: [''] },
        // 出力条件
        { field: ['inactiveFlg'], op: WhereOp.In, value: [''] },
      ]
      const where = JSON.parse(JSON.stringify(TRAN_REF_ITEM_SEARCH_CONDITION))
      const validData = this.extractCondition.validData
      setWhereValue(where, 'expireDate', validData[0], {
        ope: WhereOp.Ge,
      })
      setWhereValue(
        where,
        'referrerItem/category1',
        this.extractCondition.referrerShobunrui
      )
      setWhereValue(
        where,
        'referrerItem/category2',
        this.extractCondition.referrerClass
      )
      setWhereValue(
        where,
        'referrerItem/category3',
        this.extractCondition.referrerCategory
      )
      setWhereValue(where, 'referrerItemCd', this.extractCondition.referrerItem)
      setWhereValue(
        where,
        'refferenceItem/category1',
        this.extractCondition.referenceShobunrui
      )
      setWhereValue(
        where,
        'refferenceItem/category2',
        this.extractCondition.referenceClass
      )
      setWhereValue(
        where,
        'refferenceItem/category3',
        this.extractCondition.referenceCategory
      )
      setWhereValue(
        where,
        'refferenceItemCd',
        this.extractCondition.referenceItem
      )
      setWhereValue(where, 'inactiveFlg', [
        '0', // 削除されていないデータは必ず出力する
        ...this.outputCondition.delOutput,
      ])
      console.log({ where })
      return where
    },
    _createOrderByString() {
      const orderBy: OrderBy[] = [
        {
          field: 'referrerItemCd',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'lastModifiedDatetime',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
      ]
      console.log({ orderBy })
      return this.helper.generateQueryOrderByString(orderBy)
    },
  },
})
